export default function(x) {
  return function constant() {
    return x;
  };
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-shape/src/constant.js
// module id = PDr7
// module chunks = 0